"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceOfferingClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const client_auth_1 = require("@deliverr/client-auth");
const core_auth_1 = require("@deliverr/core-auth");
class ServiceOfferingClient extends base_client_1.ApiClient {
    constructor(config) {
        const SERVICE_OFFERING_URL = config.baseURL || process.env.PRICER_SERVICE_URL;
        if (!SERVICE_OFFERING_URL) {
            commons_logs_1.log.warn("SERVICE_OFFERING_URL environment variable is not set");
        }
        let apiClientConfig = {
            authEngine: core_auth_1.AuthEngine.COGNITO,
        };
        if (config.authEngine === core_auth_1.AuthEngine.COGNITO_INTERNAL) {
            const tokenHandler = new client_auth_1.OAuthClientTokenBuilder(config);
            apiClientConfig = {
                authEngine: core_auth_1.AuthEngine.COGNITO_INTERNAL,
                tokenRefreshFn: tokenHandler.getTokenFn(),
            };
        }
        apiClientConfig = {
            ...config,
            ...apiClientConfig,
        };
        super({
            ...apiClientConfig,
            baseURL: `${SERVICE_OFFERING_URL}`,
        });
    }
    async getServiceOfferingPricing(sellerId, referenceDate) {
        return this.get(`serviceOfferings/v1/serviceOfferingPricing`, {
            sellerId,
            referenceDate,
        });
    }
    async pricingEnabledForServiceOffering(sellerId, name, referenceDate) {
        const serviceOfferingPricing = await this.getServiceOfferingPricing(sellerId, referenceDate);
        const foundPrice = serviceOfferingPricing.find((serviceOffering) => {
            return serviceOffering.name === name;
        });
        return foundPrice?.pricingEnabled ?? false;
    }
}
exports.ServiceOfferingClient = ServiceOfferingClient;
//# sourceMappingURL=ServiceOfferingClient.js.map